import script from "./LandmarkDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./LandmarkDetail.vue?vue&type=script&setup=true&lang=js"

import "./LandmarkDetail.vue?vue&type=style&index=0&id=70ed98a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ed98a8"]])

export default __exports__